import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BiHome } from "react-icons/bi";
import { BsPerson, BsTools } from "react-icons/bs";
import {
  AiOutlineCloseCircle,
  AiOutlineFundProjectionScreen,
} from "react-icons/ai";
import { CgMenuGridO } from "react-icons/cg";
import { TbCertificate, TbSend } from "react-icons/tb";
import ThemeChangerNav from "./ThemeChangerNav";
import { Link } from "react-scroll";

function Navbar() {
  const [openNav, setOpenNav] = useState(false);
  const navHandler = () => {
    setOpenNav((state) => !state);
  };
  // animations
  const variants = {
    open: { y: 0 },
    closed: { y: "10%" },
  };
  return (
    <div className="fixed pt-2 pb-4  flex justify-between items-center max-h-16 bottom-0 md:top-0 w-screen  z-50 bg-bodyColor dark:bg-darkBodyColor">
      {/* logo */}
      <div className="md:invisible opacity-8 flex items-center justify-center font-bold text-4xl py-4 px-4 z-50">
        <ThemeChangerNav></ThemeChangerNav>
      </div>

      {/* Menu button */}
      <div
        onClick={navHandler}
        className="transition-all z-50 hover:text-firstColor opacity-80 md:cursor-pointer font-bold text-4xl  py-4 px-8  flex items-center justify-start md:hidden"
      >
        {!openNav ? (
          <CgMenuGridO></CgMenuGridO>
        ) : (
          <AiOutlineCloseCircle></AiOutlineCloseCircle>
        )}
      </div>

      {/* nav list */}
      <AnimatePresence>
        <motion.div
          className={
            openNav
              ? `md:static fixed  bottom-14 left-0 `
              : "md:static md:block hidden  bottom-14 left-0 "
          }
          animate={openNav ? "open" : "closed"}
          variants={variants}
          transition={{ duration: 0.3, ease: "easeIn" }}
        >
          <ul className="relative z-[49] md:h-full md:w-full w-screen grid grid-cols-3 gap-x-4 justify-center items-center shadow-inner font-medium md:font-semibold md:grid-cols-6  h-[30vh] px-4 lg:pr-10 bg-bodyColor dark:bg-darkBodyColor rounded-t-2xl md:rounded-none md:shadow-none">
            <li>
              <Link to="home" smooth={true} duration={400}>
                <div className="md:cursor-pointer md:hover:border-b-2 py-2 border-opacity-20  border-firstColor hover:text-firstColor transition-all flex flex-col gap-1 opacity-80 md:flex-row items-center justify-center">
                  <div className=" flex  items-center justify-center font-bold md:text-2xl text-4xl">
                    <BiHome></BiHome>
                  </div>
                  <span>Home</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="aboutMe" smooth={true} offset={50} duration={400}>
                <div className="md:cursor-pointer md:hover:border-b-2 py-2 border-opacity-20  border-firstColor hover:text-firstColor transition-all flex flex-col gap-1 opacity-80 md:flex-row items-center justify-center">
                  <div className=" flex  items-center justify-center font-bold md:text-2xl text-4xl">
                    <BsPerson></BsPerson>
                  </div>
                  <span>About Me</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="experience" smooth={true} offset={60} duration={400}>
                <div className="md:cursor-pointer md:hover:border-b-2 py-2 border-opacity-20  border-firstColor hover:text-firstColor transition-all flex flex-col gap-1 opacity-80 md:flex-row items-center justify-center">
                  <div className=" flex  items-center justify-center font-bold md:text-2xl text-4xl">
                    <BsTools></BsTools>
                  </div>
                  <span>Experience</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="projects" smooth={true} offset={60} duration={400}>
                <div className="md:cursor-pointer md:hover:border-b-2 py-2 border-opacity-20  border-firstColor hover:text-firstColor transition-all flex flex-col gap-1 opacity-80 md:flex-row items-center justify-center">
                  <div className=" flex  items-center justify-center font-bold md:text-2xl text-4xl">
                    <AiOutlineFundProjectionScreen></AiOutlineFundProjectionScreen>
                  </div>
                  <span>Projects</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="certificates" smooth={true} offset={60} duration={400}>
                <div className="md:cursor-pointer md:hover:border-b-2 py-2 border-opacity-20  border-firstColor hover:text-firstColor transition-all flex flex-col gap-1 opacity-80 md:flex-row items-center justify-center">
                  <div className=" flex  items-center justify-center font-bold md:text-2xl text-4xl">
                    <TbCertificate></TbCertificate>
                  </div>
                  <span>Certificates</span>
                </div>
              </Link>
            </li>
            <li>
              <Link to="contactMe" smooth={true} offset={60} duration={400}>
                <div className="md:cursor-pointer md:hover:border-b-2 py-2 border-opacity-20  border-firstColor hover:text-firstColor transition-all flex flex-col gap-1 opacity-80 md:flex-row items-center justify-center">
                  <div className=" flex  items-center justify-center font-bold md:text-2xl text-4xl">
                    <TbSend></TbSend>
                  </div>
                  <span>Contact Me</span>
                </div>
              </Link>
            </li>
          </ul>
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default Navbar;
